<template>
	<v-row align-content="center" >
		<v-col cols="12" lg="2" align-self="center">
			<media-gallery @selected="onSelect"/>
		</v-col>
		<v-col>
			<v-img :src="src"
				max-width="150"
			></v-img>
		</v-col>

	</v-row>
</template>

<script>
	import MediaGallery from "./MediaGallery";

	export default {
		name: "media-gallery-preview",
		props: {value: String},
		components: {MediaGallery},
		computed: {
			src: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			}
		},
		methods: {
			onSelect(val) {
				this.src = val;
			}
		}
	};
</script>

<style scoped>

</style>
